import { EuiButtonEmpty, EuiFlexGroup, EuiFlexItem } from "@inscopix/ideas-eui";
import { IDetailCellRendererParams } from "ag-grid-community";
import { CallOutError } from "components/CallOutError/CallOutError";
import { useState } from "react";
import { DetailRendererAdvanced } from "./DetailRendererAdvanced";
import { DetailRendererBase } from "./DetailRendererBase";
import { ParamsEditorRowDatum } from "components/ToolEditor/ToolEditor.types";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";

export const ADVANCED_PARAM_DETAIL_HEIGHT = 300;
export const ParameterEditorDetailRenderer = ({
  data,
  node,
  api,
}: IDetailCellRendererParams<ParamsEditorRowDatum>) => {
  const updateSpecParam = useToolEditorContext((s) => s.updateSpecParam);
  const overwriteParam = useToolEditorContext((s) => s.overwriteParam);
  const [isAdvanced, setIsAdvanced] = useState(false);

  const [normalHeight, setNormalHeight] = useState<number | null | undefined>();

  if (data === undefined) {
    return <CallOutError />;
  }

  if (isAdvanced) {
    return (
      <DetailRendererAdvanced
        data={data}
        onClose={() => {
          setIsAdvanced(false);
          node.setRowHeight(normalHeight);
          api.onRowHeightChanged();
        }}
        overwriteParam={overwriteParam}
      />
    );
  }

  return (
    <EuiFlexGroup
      direction="column"
      style={{ padding: "15px 15px 5px 15px" }}
      gutterSize="none"
    >
      <EuiFlexItem grow={false}>
        <DetailRendererBase data={data} updateSpecParam={updateSpecParam} />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiButtonEmpty
          size="xs"
          style={{ width: 150, alignSelf: "flex-end" }}
          onClick={() => {
            setIsAdvanced(true);
            setNormalHeight(node.rowHeight);
            node.setRowHeight(ADVANCED_PARAM_DETAIL_HEIGHT);
            api.onRowHeightChanged();
          }}
        >
          Advanced mode
        </EuiButtonEmpty>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
